<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="dateFormatted"
        :label="name"
        color="secondary"
        readonly
        v-on="on"
      >
        <v-tooltip slot="append" top>
          <v-icon slot="activator">info_outline</v-icon>
          <span>{{ description }}</span>
        </v-tooltip>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :type="datePickerType"
      no-title
      @change="setValueByDate(date)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    date_type: {
      type: String,
      required: true,
    },
    date_format: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
    };
  },
  computed: {
    dateFormatted() {
      return this.date ? this.$dayjs(this.date).format(this.date_format) : "";
    },
    datePickerType() {
      return this.date_type == "month" ? "month" : "date";
    },
  },
  created() {
    const format = this.date_type == "month" ? "YYYY-MM" : "YYYY-MM-DD";
    if (this.value) {
      this.date = this.$dayjs(this.value).format(format);
    } else {
      this.$emit("updateFieldValue", this.$dayjs(this.date).format(format));
    }
  },
  methods: {
    setValueByDate(date) {
      this.menu = false;
      this.$emit("updateFieldValue", date);
    },
  },
};
</script>
